import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const BuildingSelector = ({ selectedBuildings, onBuildingChange, availableBuildings }) => {
  const buildingOptions = availableBuildings?.map(building => ({
    value: building?.id,
    label: building?.name,
    description: `${building?.totalRooms} rooms • ${building?.floors} floors`
  }));

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
          <Icon name="Building2" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground">Building Comparison</h3>
          <p className="caption text-muted-foreground">Select up to 4 facilities to compare</p>
        </div>
      </div>
      <Select
        label="Select Buildings"
        description="Choose buildings to analyze performance metrics"
        multiple
        searchable
        clearable
        options={buildingOptions}
        value={selectedBuildings}
        onChange={onBuildingChange}
        placeholder="Select buildings..."
        className="mb-4"
      />
      <div className="flex flex-wrap gap-2">
        {selectedBuildings?.map(buildingId => {
          const building = availableBuildings?.find(b => b?.id === buildingId);
          return (
            <div
              key={buildingId}
              className="flex items-center gap-2 px-3 py-2 bg-primary/10 text-primary rounded-lg text-sm"
            >
              <Icon name="Building" size={14} />
              <span className="font-medium">{building?.name}</span>
              <button
                onClick={() => onBuildingChange(selectedBuildings?.filter(id => id !== buildingId))}
                className="ml-1 hover:bg-primary/20 rounded-full p-1 transition-smooth"
                aria-label={`Remove ${building?.name}`}
              >
                <Icon name="X" size={12} />
              </button>
            </div>
          );
        })}
      </div>
      {selectedBuildings?.length === 0 && (
        <div className="mt-4 p-4 bg-muted rounded-lg text-center">
          <Icon name="AlertCircle" size={24} className="text-muted-foreground mx-auto mb-2" />
          <p className="caption text-muted-foreground">Select at least one building to view performance data</p>
        </div>
      )}
    </div>
  );
};

export default BuildingSelector;